<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { useOptimisationStore } from '@/stores/optimisation'
import { useAuthorizationStore } from '@/stores/authorization'

import OptimisationTextField from '@/components/optimisation/OptimisationTextField.vue'

const authorizationStore = useAuthorizationStore()

const { fields } = storeToRefs(useOptimisationStore())

const canEdit = computed(() =>
  authorizationStore.hasServicePermission({
    authSource: 'ProjectUser',
    allowed: 'change_optimisation'
  })
)
</script>

<template>
  <v-card v-if="fields" variant="flat" :disabled="!canEdit" style="border-radius: 0">
    <v-table density="compact" no-label no-padding hover class="d-flex flex-column">
      <thead>
        <tr>
          <th class="text-left">Allowable line angles</th>
          <th class="text-center">Recommended angle (°)</th>
          <th class="text-center">Maximum (°)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="th">Horizontal - breast lines</td>
          <td>
            <OptimisationTextField field="recommended_breast_line_angle" />
          </td>
          <td>
            <OptimisationTextField field="max_breast_line_angle" />
          </td>
        </tr>
        <tr>
          <td class="th">Horizontal - spring lines</td>
          <td>
            <OptimisationTextField field="recommended_spring_line_angle" />
          </td>
          <td>
            <OptimisationTextField field="max_spring_line_angle" />
          </td>
        </tr>
        <tr>
          <td class="th">Horizontal - bow/stern lines</td>
          <td>
            <OptimisationTextField field="recommended_bow_stern_line_angle" />
          </td>
          <td>
            <OptimisationTextField field="max_bow_stern_line_angle" />
          </td>
        </tr>
        <tr>
          <td class="th">Vertical - all lines</td>
          <td>
            <OptimisationTextField field="recommended_vertical_angle" />
          </td>
          <td>
            <OptimisationTextField field="max_vertical_angle" />
          </td>
        </tr>
      </tbody>
    </v-table>
  </v-card>
</template>
